/** Si los ajustes del widget abiertos tienen cambios sin guardar (la bandeja y la PWA lo miran antes de irse o recargar). */
export const unsavedSettings = { current: false };
